import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "@nuxtjs/composition-api";

import { useAmplitude, useVuetify } from "@/composables";
import { time } from "@/utils/enums/time";
import { isTiktokIAB } from "@/utils/iab-identification";


export default /*#__PURE__*/_defineComponent({
  __name: 'TikTokNotification',
  setup(__props) {

const amplitude = useAmplitude();
const vuetify = useVuetify();

const showNotification = ref(false);

onMounted(() => {
  setTimeout(() => {
    if (checkForTikTokIAB()) {
      showNotification.value = true;
    }
  }, time.THREE_SECONDS);
});

const onClose = () => {
  showNotification.value = false;
  amplitude?.sendEvent("/dismiss-web-vpm", { "vpm-type": "open in browser" });
};

const checkForTikTokIAB = () => {
  return vuetify.breakpoint.xsOnly && isTiktokIAB();
};

return { __sfc: true,amplitude, vuetify, showNotification, onClose, checkForTikTokIAB }
}

})